//App name
export const APP_NAME = 'Prep2Pass';
//LogOut
export const LOGOUT_MESSAGE = 'Are you sure you want to logout?';

//Common screen titles
export const FLASHCARD_SCREEN_TITLE = 'Flashcards';
export const LOGIN = 'Login';
export const SIGNIN = 'Sign In';
export const SIGN_UP = 'Sign Up';
export const SESSION_EXPIRED = 'Session Expired';
export const SIGNINTO = 'Sign in to Prep2Pass';
export const SIGNUPTO = 'Sign up to Prep2Pass';

//Common Validations
export const FULL_NAME_REQUIRED = 'Full name can\'t be empty.';
export const NMLS_NUMBER_REQUIRED = 'Nmls number can\'t be empty.';
export const FULL_NAME_LENGTH_ERROR =
  'Full name must be at least 2 characters long.';
export const EMAIL_REQUIRED = 'Email can\'t be blank.';
export const INVALID_EMAIL = 'Invalid Email.';
export const PASSWORD_REQUIRED = 'Password can\'t be blank';
export const SELECT_COMPANY_NAME = 'Please select company name';
export const TERMS_CONDITIONS = 'Please accept Terms of Use';

//Common Return Key
export const DONE = 'done';
export const NEXT = 'next';
export const GO = 'go';
export const OK = 'OK';
export const CANCEL = 'Cancel';

//Reset card
export const RESET_DONE = 'Questions successfully reset';
export const RESET_FAIL = 'Questions reset fail';

//Common KeyBoard Type

//Common PlaceHolders
export const EMAIL_PLACEHOLDER = 'Email';
export const PASSWORD_PLACEHOLDER = 'Password';

//Card Face
export const CARD_FRONT_FACE = 'front';
export const CARD_BACK_FACE = 'back';

export const CHOOSE_CORRECT_ANSWER = 'Choose the correct answer';

//Internet check
export const INTERNET_CHECK = 'Please check your internet connection';
export const OFFLINE_USER = 'You are offline';

//Payment
export const PAYMENT_FAIL = 'Failed to get pay ammount';

//Login Check
export const LOGIN_SUCCESS = 1;
export const LOGIN_FAILED = 2;
export const LOGOUT = 3;

//Feed back
export const EMAIL_ID = 'trainer@diehl1.com';
export const EMAIL_SUBJECT = 'Prep2Pass Ask The Instructor';
export const EMAIL_BODY = '';
export const FEEDBACK_TEXT = 'Email the instructor at';
export const SOMETHING_WRONG = 'Something went wrong';

//Simulated Test//1 test 2//submit page 3//list page,4 for question modal
export const INITIAL_TEST = 1;
export const SUBMIT_PAGE = 2;
export const LIST_PAGE = 3;
export const QUESTION_MODAL = 4;

export const FIFTY_FLASH_CARDS = 50;
export const TWENTY_FIVE_QUESTIONS = 25;
export const UNATTEMPTED_QUESTIONS_STATUS = 1;
export const ATTEMPTED_QUESTIONS_STATUS = 2;
export const MARKED_FOR_REVIEW_QUESTIONS_STATUS = 3;
export const MARKED_FOR_REVIEW_QUESTIONS = 'Review Questions';
export const SIMULATED_TEST_TITLE = 'Test';
export const SIMULATED_TEST_COMPLETED = 'Simulated Test';
export const UNATTEMPED_QUESTIONS = 'Unattempted questions';
export const ATTEMPTED_QUESTIONS = 'Attempted questions';
export const NO_QUESTIONS_IN_CATEGORY = 'No question in this category';

//Server Response
export const SESSION_EXPIRED_CODE = 401;

export const PromptButtons = {
  ok: 'OK',
  done: 'Done',
  cancel: 'Cancel',
};

export const Strings = {
  chooseCorrectAnswer: 'Choose the correct answer',
  submitAnswer: 'Submit Answer',
  notSeeQuestionAgain: 'Click to not see this question again',
  continue: 'Continue',
  youAreCorrect: 'You are correct',
  thatsNotCorrect: 'Sorry, that\'s not correct.',
  description: 'Description',
  correctAnswerIs: 'The correct answer is:',
  dashboard: 'Dashboard',
  achievements: 'Achievements',
  INCORRECT_ANSWER: 'Incorrect',
  CORRECT_ANSWER: 'Correct',
  enterOldPassword: 'Please enter your old password',
  enterNewPassword: 'Please enter your new password',
  confirmNewPassword: 'Please confirm your new password.',
  passwordsMismatch: 'Passwords mismatch.',
  purchaseMessage:
    'You need to purchase the app from dashboard in order to proceed further.',
  purchaseTitle: 'Purchase the App',
  simulatedTest: 'Simulated Test',
  invalidOldPassword: 'Old password is incorrect.',
  startSimulatedTest: 'Start Simulated Test',
  CHOOSE_CORRECT_ANSWER: 'Choose the correct answer',
  HIDE_ANSWER_ALERT: 'Do you want to hide this question?',
  markForReview: 'Mark for review',
  nameEmpty: 'Name can\'t be empty',
  emailsAt: 'Email the instructor at',
  //Button Tex
  SUBMIT_ANSWER: 'Submit Answer',
  CONTITNUE: 'Continue',

  SIMULATED_TEST_TITLE: 'Test',
  SIMULATED_TEST_COMPLETED: 'Simulated Test',
  MARKED_FOR_REVIEW_QUESTIONS: 'Review Questions',
  UNATTEMPED_QUESTIONS: 'Unattempted questions',
  ATTEMPTED_QUESTIONS: 'Attempted questions',
  NO_QUESTIONS_IN_CATEGORY: 'No question in this category',

  SECTION_TEXT: 'section',
  QUESTION_TEXT: 'Question',

  //Questions Link
  COURSE_MANUAL_LINK: 'Click here for the course manual',
  ERGS_LINK: 'Click here for E-regs',
  HIDE_QUESTION_LINK: 'Click here to not see this question again',
  FILLUP_TAG: '<f>',

  //Result Description
  CORRECT_RESULT_DESCRIPTION: 'You are correct',
  INCORRECT_RESULT_DESCRIPTION: 'Sorry, that\'s not correct.',
};

export const TEST_INSTRUCTIONS = [
  'Congratulations you have reached the simulated Tests!',
  'Once you have completed the course, flashcards, and questions, the simulated tests will measure your comprehension so you focus on what’s most relevant to you passing the National Test.',
  'When you find topics and information that you still need to master, you can:',
  'Return to the course text and search for specific topics',
  'Review videos under the video tab on those topics',

  'Simulated tests can be taken over and over. Results are shown at the end along with missed questions and correct answers.',
  'Do not memorize questions. Identify and review information in the book or watch videos to fully prepare for the National Test.',
  'Each simulated Test is 125 questions and covers content on the Safe Mortgage Loan Originator Test.',
  'When you begin each Test, a timer will appear in the upper right-hand corner of the screen and countdown from 190 minutes which is the maximum time allowed. Choose the most correct answer for each question.',
  'If you are unsure about an answer to any question, check the “mark for review” box at the bottom of the screen. This creates a “short list“ of questions for you to look at before submitting the test for grading.',
  'The app also allows you to challenge other users and provides a list of missed questions along with correct answers.',
  'Once an Test is started, it must completed in its entirety or you will have to start again from the beginning.',
  'Good Luck!',
  'Scott Weghorst and the Diehl Team',
  'www.diehl1.com',
];

export const INTRO_HEADING = 'Thank you for using Prep2Pass.';

export const INTRO_INSTRUCTIONS = [
  'If you need to take the 20 hour pre-licensing course, use this coupon for $50 off: P2PBONUS.',
  'Sign up at www.diehl1.com or email us at support@diehl1.com with questions.',
  'Sign up with the same email that you used for prep to pass to get the discount.',
  'After you pass the NMLS test, the benefits don’t stop. Return here to access more tools and resources that you can use to drive your business forward.',
];

export const toolsAndResources_URL = 'https://diehlmember.com/login/';
